import React from "react";
import { InputDashboard } from "../../components/User/Input/InputDashboard";
import { Content } from "../../components/ui/ContentArea";

export const InputPage: React.FC = () => {
	return (
		<Content className="p-5">
			<title>Editar Referencias Consumo</title>
			<InputDashboard />
		</Content>
	);
};
